<template>
  <a-config-provider :locale="Locale">
    <a-card v-bind:size="IsDetailUserForm ? 'small' : 'default'">
      <template slot="title">
        <!--头部标题插槽-->
        <slot name="header-title">
          <span v-if="!IsDetailUserForm">
            <!-- <a-icon v-else type="appstore"></a-icon> -->
            {{ ListPanelTitle }}
            <cg-help
              v-if="CurUserForm.IsShowHelpDoc"
              :width="800"
              :userFormId="CurUserForm.UserFormID"
            ></cg-help>
          </span>
        </slot>
      </template>
      <template slot="extra">
        <!--头部扩展插槽-->
        <slot name="header-extra"></slot>
        <a-dropdown :trigger="['click']" v-if="IsSysAdmin || CurUserForm.AllowToExcel">
          <a-button type="link" icon="setting"></a-button>
          <a-menu slot="overlay">
            <a-menu-item v-if="CurUserForm.AllowToExcel" @click="OnDownloadExcelClick">
              导出Excel
            </a-menu-item>
            <a-menu-item v-if="IsSysAdmin" @click="OnSetColClick">
              界面配置
            </a-menu-item>
            <a-menu-item v-if="IsSysAdmin" @click="OnDebugSelectSqlClick">
              调试表单SelectSql
            </a-menu-item>
            <a-menu-item v-if="IsSysAdmin" @click="OnAdvancedCfgClick">
              用户表单高级配置
            </a-menu-item>
            <a-menu-item v-if="IsSysAdmin" @click="OnImportCsvClick">
              导入Csv
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <!--明细表单添加数据-->
        <a-button
          v-if="IsDetailUserForm && CurUserForm.AllowAdd"
          type="link"
          icon="plus"
          @click="OnAddClick"
        >
        </a-button>
        <!--明细表单刷新-->
        <!-- <a-button
          v-if="IsDetailUserForm"
          type="link"
          icon="reload"
          @click="RestoreOriginalData"
        >
        </a-button> -->
      </template>

      <!--工具条-->
      <div class="cg-list-toolbar">
        <div class="cg-list-toolbar-left">
          <!--工具条左边按钮插槽-->
          <slot name="toolbar-left-btn" v-if="!IsDetailUserForm">
            <a-button
              icon="rollback"
              v-show="IsShowPreUserForm"
              @click="OnReturnPreUserFormClick"
            >
              返回
            </a-button>
            <a-button icon="plus" v-if="CurUserForm.AllowAdd" @click="OnAddClick">
              添加
            </a-button>
            <a-button icon="delete" v-if="CurUserForm.IsNeedBatchDelete" @click="OnBatchDeleteClick">
              批量删除
            </a-button>
          </slot>
          <!--工具条左边插槽-->
          <slot name="toolbar-left"></slot>
        </div>
        <div class="cg-list-toolbar-right">
          <!--工具条右边插槽-->
          <slot name="toolbar-right">
            <cg-advanced-search
              v-if="!IsDetailUserForm"
              :search-col-list="SearchColList"
              @search="OnSearch"
            ></cg-advanced-search>
          </slot>
        </div>
      </div>

      <!--表格-->
      <slot name="table">
        <cg-data-table
          class="cg-list-table"
          ref="DataTable"
          v-bind:key-col-name="CurUserForm.KeyColName"
          v-bind:col-info-list="CurUserForm.ColInfoRecList"
          v-bind:rec-list-data="CurUserForm.RecListData"
          v-bind:allow-modify="CurUserForm.AllowModify"
          v-bind:allow-dell="CurUserForm.AllowDell"
          v-bind:is-show-row-opt="CurUserForm.IsShowRowOpt"
          v-on:title-sort="OnTitleSort"
          v-on:sort-click="OnSortClick"
          v-on:view-click="OnViewClick"
          v-on:update-click="OnUpdateClick"
          v-on:delete-click="OnDeleteClick"
          v-on:row-select-change="OnRowSelectChange"
        >
          <!--表格字段插槽-->
          <!-- <template slot="col-prize_id" slot-scope="{ recData, colInfo }">{{recData.prize_id}}</template> -->
          <template
            v-for="item in SlotColInfoList"
            :slot="'col-' + item.ColName.toLowerCase()"
            slot-scope="{ recData }"
          >
            <slot
              :name="'col-' + item.ColName.toLowerCase()"
              :recData="recData"
              :colInfo="item"
            ></slot>
          </template>
        </cg-data-table>
      </slot>

      <!--底部-->
      <div class="cg-list-footer">
        <div class="cg-list-footer-left">
          <!--底部左边插槽-->
          <slot name="footer-left">
            共 {{ CurUserForm.DataPaging.RecCount }} 条记录
          </slot>
        </div>
        <div class="cg-list-footer-right">
          <!--底部右边插槽-->
          <slot name="footer-right">
            <cg-data-paging
              v-model="CurUserForm.DataPaging.CurPage"
              :total="CurUserForm.DataPaging.RecCount"
              :page-size="CurUserForm.DataPaging.PageSize"
              @change="OnCurPageChange"
              @show-size-change="OnPageSizeChange"
            ></cg-data-paging>
          </slot>
        </div>
      </div>
    </a-card>
  </a-config-provider>
</template>
<script>
import ListPanelMixin from "./ListPanelMixin";

export default {
  mixins: [ListPanelMixin],
  computed: {
    SlotColInfoList() {
      let _colInfoList = [];

      let _keys = new Set(
        Object.keys(this.$scopedSlots).concat(Object.keys(this.$slots))
      );

      for (let _key of _keys) {
        if (_key.indexOf("col-") === 0 && _key.length > 4) {
          let _colName = _key.substring(4);

          let _colInfo = this.CurUserForm.ColInfoRecList.find(
            (item) => item.ColName.toLowerCase() === _colName.toLowerCase()
          );

          if (_colInfo) {
            _colInfoList.push(_colInfo);
          }
        }
      }

      return _colInfoList;
    },
    IsDetailUserForm() {
      return this.CurUserForm.Type === "DetailUserForm";
    },
  },
  methods: {
    RestoreOriginalData() {
      if (this.CurUserForm.TableCache) {
        this.CurUserForm.TableCache.RestoreOriginalData();
        this.CurUserForm.RefreshData(true);
      }
    },
  },
};
</script>
